/*
 * Senchado content snippets hydrator
 * 旧テーマの本文埋め込み独自タグを新テーマへ移植:
 *   <span class="product-snippet" data-url=".../products/<handle>"></span>
 *   <span class="article-snippet" data-url=".../blogs/<blog>/<article>"></span>
 * 記事・商品・ページ本文（.rte）内の空 span をカードにハイドレートする。
 * - product: data-url の handle から /products/<handle>.js を取得（#product-meta 不要・堅牢）
 * - article: data-url 先の og:title / og:image[:secure_url] / og:url ＋ #blog-data[data-blogtitle]
 */
(function () {
  'use strict';

  function handleFromUrl(u) {
    try {
      var path = new URL(u, window.location.origin).pathname;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function yen(n) {
    return '¥' + Math.round(n / 100).toLocaleString('ja-JP');
  }

  function hydrateProduct(elm) {
    var handle = handleFromUrl(elm.dataset.url);
    if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product not found'); return r.json(); })
      .then(function (p) {
        var wrap = document.createElement('div');
        wrap.className = 'product-snippet-wrapper';
        // 季節のお茶の欄だけ（data-sold-out-badge）。旧来の本文埋め込みカードの見た目は変えない。
        // 販売開始前（data-sell-pending）は在庫があっても買えないので札を出す
        var soldOut = elm.hasAttribute('data-sold-out-badge') && (p.available === false || elm.hasAttribute('data-sell-pending'));
        if (soldOut) wrap.className += ' is-sold-out';
        var a = document.createElement('a');
        a.href = p.url || elm.dataset.url;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image;
          img.alt = p.title || '';
          img.loading = 'lazy';
          img.width = 100; img.height = 100;
          a.appendChild(img);
        }
        var tw = document.createElement('div');
        tw.className = 'product-snippet-text-wrapper';
        var t = document.createElement('p');
        t.className = 'product-title';
        t.textContent = p.title || '';
        tw.appendChild(t);
        var price = document.createElement('span');
        price.className = 'product-snippet-price';
        price.textContent = (p.price_min !== p.price_max)
          ? (yen(p.price_min) + ' 〜 ' + yen(p.price_max))
          : yen(p.price);
        tw.appendChild(price);
        if (soldOut) {
          var badge = document.createElement('span');
          badge.className = 'product-snippet-soldout';
          // 文言はテーマの翻訳（一覧のページの札と同じ）を Liquid から受け取る
          badge.textContent = elm.getAttribute('data-sold-out-badge') || '売り切れ';
          tw.appendChild(badge);
        }
        a.appendChild(tw);
        wrap.appendChild(a);
        elm.appendChild(wrap);
      })
      .catch(function () { /* 商品が無ければ空のまま */ });
  }

  function hydrateArticle(elm) {
    var url = elm.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        function meta(prop) {
          var m = doc.querySelector('head meta[property="' + prop + '"]');
          return m ? m.getAttribute('content') : '';
        }
        var title = meta('og:title');
        var href = meta('og:url') || url;
        var image = meta('og:image:secure_url') || meta('og:image');
        var bd = doc.querySelector('#blog-data');
        var blogTitle = bd ? (bd.dataset.blogtitle || '') : '';

        var wrap = document.createElement('div');
        wrap.className = 'article-snippet-wrapper';
        var a = document.createElement('a');
        a.href = href;
        if (image) {
          var img = document.createElement('img');
          img.src = image;
          img.alt = title || '';
          img.loading = 'lazy';
          img.width = 80; img.height = 80;
          a.appendChild(img);
        }
        var tw = document.createElement('div');
        tw.className = 'article-snippet-text-wrapper';
        if (blogTitle) {
          var bt = document.createElement('span');
          bt.className = 'article-snippet-blog-title';
          bt.textContent = blogTitle;
          tw.appendChild(bt);
        }
        var t = document.createElement('p');
        t.className = 'article-title';
        t.textContent = title || '';
        tw.appendChild(t);
        a.appendChild(tw);
        wrap.appendChild(a);
        elm.appendChild(wrap);
      })
      .catch(function () {});
  }

  function run() {
    var P = document.querySelectorAll('.product-snippet:not([data-sc-hydrated])');
    for (var i = 0; i < P.length; i++) {
      P[i].setAttribute('data-sc-hydrated', '');
      if (P[i].dataset.url) hydrateProduct(P[i]);
    }
    var A = document.querySelectorAll('.article-snippet:not([data-sc-hydrated])');
    for (var j = 0; j < A.length; j++) {
      A[j].setAttribute('data-sc-hydrated', '');
      if (A[j].dataset.url) hydrateArticle(A[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
